import { defineMessages } from 'react-intl'

const messages = defineMessages({
  imgLink: {
    id: 'PanelsDevelopmentMethodology.imgLink',
    description: 'Link a la imagen por idiomas',
    defaultMessage: '/img/ES-Marco-completo-sincabecera.png'
  },
  methodology: {
    id: 'PanelsDevelopmentMethodology.methodology',
    description: 'Texto para el título de la página sobre la metodología',
    defaultMessage: 'Metodología'
  },
  framework: {
    id: 'PanelsDevelopmentMethodology.framework',
    description: 'Titulo',
    defaultMessage: 'Marco de competitividad de Orkestra'
  },
  introductionParagraph1: {
    id: 'PanelsDevelopmentMethodology.introductionParagraph1',
    description: 'Párrafo introductorio 1',
    defaultMessage:
      'En Orkestra utilizamos un marco para analizar la competitividad territorial que propone una serie de elementos esenciales a la hora de identificar las claves de la competitividad al servicio del bienestar inclusivo y sostenible.'
  },
  introductionParagraph2: {
    id: 'PanelsDevelopmentMethodology.introductionParagraph2',
    description: 'Párrafo introductorio 2',
    defaultMessage:
      'Este marco, que presentamos en el <a href="https://www.orkestra.deusto.es/es/investigacion/informe-de-competitividad-del-pais-vasco-2021" class="font-weight-bold" target="_blank">Informe de Competitividad del País Vasco 2021</a>, también nos ayuda a poner en marcha estrategias e iniciativas para el fomento de la competitividad al servicio del bienestar de las personas.'
  },
  level1Paragraph: {
    id: 'PanelsDevelopmentMethodology.level1Paragraph',
    description: 'Parrafo sobre el nivel 1',
    defaultMessage:
      'En el centro del marco <span class="obs-dimension-0 font-weight-bold">(en azul)</span> encontramos las <a class="font-weight-bold" href="{dimensionLink0}">dimensiones de resultado económico-empresarial</a>, que típicamente forman parte del análisis de la competitividad territorial, y las <a href="{dimensionLink0}" class="font-weight-bold">dimensiones de bienestar</a>, a cuyas necesidades debería responder en última instancia la competitividad territorial.'
  },
  level2Paragraph: {
    id: 'PanelsDevelopmentMethodology.level2Paragraph',
    description: 'Parrafo sobre el nivel 2',
    defaultMessage:
      'En la parte izquierda <span class="obs-dimension-2 font-weight-bold">(en naranja)</span> se sitúa el <a class="font-weight-bold" href="{dimensionLink02}">contexto estructural</a> del territorio, que incluye características que, en gran medida, vienen dadas y que no son ni buenas ni malas per se. Estos elementos cambian lentamente en el tiempo, pero es posible provocar cambios en algunos de ellos en el medio-largo plazo a través de políticas o estrategias enfocadas en las palancas dinámicas.'
  },
  level3Paragraph: {
    id: 'PanelsDevelopmentMethodology.level3Paragraph',
    description: 'Parrafo sobre el nivel 3',
    defaultMessage:
      'A la derecha <span class="obs-dimension-3 font-weight-bold">(en verde)</span> están las <a class="font-weight-bold" href="{dimensionLink3}">palancas dinámicas</a> de la competitividad, que incluyen todos los factores que inciden de alguna manera en la competitividad y el bienestar del territorio y sobre las que las políticas y las estrategias (de los actores, los gobiernos y el territorio en sí) pueden incidir para marcar la dirección en que se debe avanzar, así como promover cambios en el medio-largo plazo en ciertos elementos del contexto estructural.'
  },
  level4Paragraph: {
    id: 'PanelsDevelopmentMethodology.level4Paragraph',
    description: 'Parrafo sobre el nivel 4',
    defaultMessage:
      'Completan el marco dos dimensiones transversales: la <strong>inclusividad</strong>, que se manifiesta de distintas maneras que pueden ser más o menos relevantes según la dimensión analizada (desigualdades de riqueza, género, raza, edad, orientación sexual, discapacidad, etc.), y la <strong>conexión internacional</strong>, que está vinculada tanto a los resultados económico-empresariales como a los análisis de las dimensiones del bienestar y de las palancas.'
  },
  dimensionColophonParagraph1: {
    id: 'PanelsDevelopmentMethodology.dimensionColophonParagraph1',
    description: 'Parrafo final sobre dimensiones',
    defaultMessage:
      'Partiendo de este marco se selecciona una batería de indicadores relevantes dentro de cada dimensión, que se va contrastando y actualizando continuamente en los diferentes proyectos e informes realizados por Orkestra.'
    },
  geographicalScope: {
    id: 'PanelsDevelopmentMethodology.geographicalScope',
    description: 'Titulo alcance geográfico',
    defaultMessage: 'Alcance geográfico'
  },
  geographicalScopeParagraph1: {
    id: 'PanelsDevelopmentMethodology.geographicalScopeParagraph1',
    description: 'Parrafo sobre el alcance geográfico 1',
    defaultMessage:
      'El Observatorio de Competitividad de Orkestra abarca datos regionales a nivel europeo. La subdivisión en regiones utilizadas se basa en los niveles NUTS (<a href="https://ec.europa.eu/eurostat/web/nuts/background"> Nomenclature des Unités Territoriales Statistiques</a>) definidos por la Unión Europea.'
  },
  geographicalScopeParagraph2: {
    id: 'PanelsDevelopmentMethodology.geographicalScopeParagraph2',
    description: 'Parrafo sobre el alcance geográfico 2',
    defaultMessage:
      'Puesto que el ámbito geográfico de las subdivisiones NUTS varía de estado miembro a estado miembro, en nuestro análisis utilizamos una	combinación de niveles NUTS2 y NUTS1, eligiendo el nivel que mejor se aproxime a las divisiones administrativas de cada país.'
  },
  temporalScope: {
    id: 'PanelsDevelopmentMethodology.temporalScope',
    description: 'Titulo alcance temporal',
    defaultMessage: 'Alcance temporal'
  },
  temporalScopeParagraph: {
    id: 'PanelsDevelopmentMethodology.temporalScopeParagraph',
    description: 'Parrafro sobre el alcance temporal',
    defaultMessage:
      'Este panel se basa en una plataforma de datos de Orkestra que actualiza continuamente los indicadores en función de su disponibilidad.	Cuando se utilizan datos que requieren un tratamiento mínimo su actualización es automática.En los casos de datos que han de ser tratados	estadísticamente en Orkestra la actualización puede llevar algo más de tiempo. En todo caso, si hay algo que te llama la atención, no dudes en ponerte en <a href="mailto:behatoki@orkerstra.deusto.es">contacto con nosotr@s</a >.'
  },
  dataSources: {
    id: 'PanelsDevelopmentMethodology.dataSources',
    description: 'Titulo Fuentes de datos',
    defaultMessage: 'Fuentes de datos'
  },
  dataSourcesParagraph: {
    id: 'PanelsDevelopmentMethodology.dataSourcesParagraph',
    description: 'Parrafo sobre fuentes de datos',
    defaultMessage: 'Las fuentes primarias de los datos utilizados para la elaboración de este panel son:'
  },
  dataSourcesItem1: {
    id: 'PanelsDevelopmentMethodology.dataSourcesItem1',
    description: 'Primer item de la lista sobre fuentes de datos',
    defaultMessage: '<a href="https://ec.europa.eu/eurostat" target="_blank">Eurostat</a>, la oficina estadística de la Unión Europea.'
  },
  dataSourcesItem2: {
    id: 'PanelsDevelopmentMethodology.dataSourcesItem2',
    description: 'Segundo item de la lista sobre fuentes de datos',
    defaultMessage:
      'La base de datos <a href="https://www.oecd-ilibrary.org/science-and-technology/the-oecd-regpat-database_241437144144" target="_blank">REGPAT</a> de la <a href="https://www.oecd.org/" target="_blank">OECD</a> [explotada estadísticamente en Orkestra].'
  },
  dataSourcesItem3: {
    id: 'PanelsDevelopmentMethodology.dataSourcesItem3',
    description: 'Tercer item de la lista sobre fuentes de datos',
    defaultMessage:
      'La Encuesta Social Europea (<a href="https://www.europeansocialsurvey.org/" target="_blank">European Social Survey</a>) [explotada estadísticamente en	Orkestra].'
  },
  dataSourcesItem4: {
    id: 'PanelsDevelopmentMethodology.dataSourcesItem4',
    description: 'Tercer item de la lista sobre fuentes de datos',
    defaultMessage:
      '<a href="https://www.eustat.eus" target="_blank">EUSTAT</a> para los datos de la C.A. de Euskadi cuando son metodológicamente comparables a los de Eurostat'
  },
  temporalSeriesCompletion: {
    id: 'PanelsDevelopmentMethodology.temporalSeriesCompletion',
    description: 'Titulo completado de series temporales',
    defaultMessage: 'Completado de series temporales'
  },
  temporalSeriesCompletionParagraph: {
    id: 'PanelsDevelopmentMethodology.temporalSeriesCompletionParagraph',
    description: 'Parrafo sobre completado de series temporales',
    defaultMessage:
      'En la mayor parte de los casos se disponen de datos para todas las regiones europeas consideradas y con marco temporal comparable entre	ellas. En otras ocasiones nuestra plataforma de datos se encarga de estimar valores perdidos de forma que podamos ofrecer las series más	completas posibles. Los métodos de estimación se adecúan a cada indicador y abarcan triangulaciones, interpolaciones lineales, resolución y herencia jerárquicas o repetición de la última observación.'
  },
  indicatorCalculation: {
    id: 'PanelsDevelopmentMethodology.indicatorCalculation',
    description: 'Titulo Explotación y cálculo de indicadores',
    defaultMessage: 'Explotación y cálculo de indicadores'
  },
  indicatorCalculationParagraph: {
    id: 'PanelsDevelopmentMethodology.indicatorCalculationParagraph',
    description: 'Parrafo sobre la explotación y cálculo de indicadores',
    defaultMessage:
      'Además de utilizar datos provenientes directamente de las fuentes utilizadas, en otras ocasiones realizamos cálculos combinando diferentes indicadores para obtener uno nuevo que refleje mejor la realidad que intentamos monitorizar.'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/PanelsDevelopmentMethodology/messages.js